import { ChangeDetectionStrategy, Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { FiChecklist2ReportType } from '../../../../enums/fi-checklist2-report-type';
import {
    IChecklistV2FilterAvailableItems,
    IChecklistV2ReportParameter,
    IChecklistV2ReportParameterFilter,
} from '../../../../shared/fi-checklist2-report';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { IChecklist2ReportViewData } from '../../../../shared/fi-checklist2-report-data';

@Component({
    selector: 'fi-checklist2-report-new-widget-data-wrapper',
    templateUrl: './new-widget-filter-data-wrapper.component.html',
    styleUrls: ['./new-widget-filter-data-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-report-new-widget-data-wrapper' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiChecklist2ReportNewWidgetDataFilterWrapperComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiChecklist2ReportNewWidgetDataFilterWrapperComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiChecklist2ReportNewWidgetDataFilterWrapperComponent extends ControlValueAccessorValidatorBase<IChecklistV2ReportParameter> {
    @Input() reportData: IChecklist2ReportViewData;
    //isWidgetNameInputShown: boolean = false;

    get availableItems(): IChecklistV2FilterAvailableItems {
        return this.reportData.availableItems;
    }
    get reportParam(): IChecklistV2ReportParameter {
        return this.ngModel;
    }

    constructor(private injector: Injector) {
        super(injector);
    }

    private isFilterApplied(): boolean {
        if (!this.reportParam.Settings?.Filters.length) return false;

        return Object.keys(this.reportParam.Settings.Filters[0]).length > 1;
    }

    /*toggleWidgetNameVisibility() {
        this.isWidgetNameInputShown = !this.isWidgetNameInputShown;
    }*/

    currentFilterChange(newFilterData: IChecklistV2ReportParameterFilter) {
        this.reportParam.Settings.Filters = [newFilterData];
        this.reportParam.Settings.CurrentFilterGuid = newFilterData.Guid;
        this.onReportParamChange(this.reportParam);
    }

    onReportParamChange(newReportParam: IChecklistV2ReportParameter) {
        this.ngModel = newReportParam;
        this.doPropagateChanges();
    }

    doValidate(): ValidationErrors {
        const errors: ValidationErrors = {
            'name-required': !this.reportParam.Name?.trim().length,
            'filter-required': !this.isFilterApplied(),
        };
        return errors;
    }

    protected readonly FiChecklist2ReportType = FiChecklist2ReportType;
}
